import React from "react";
import { Button, Modal } from "../../../components";

interface DeleteInvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteInvoiceModal: React.FC<DeleteInvoiceModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete invoice?"
      subtitle="Are you sure you want to delete this?
      This action cannot be undone."
      variant="expanded"
      className="cx-max-w-[480px]"
    >
      <div className="cx-flex cx-flex-col cx-gap-6 cx-max-w-[480px]">
        <div className="cx-flex cx-gap-3">
          <Button
            label="Cancel"
            onClick={onClose}
            fullWidth
            secondary
            applyBorder
          />
          <Button
            label="Delete"
            onClick={handleConfirm}
            className="cx-bg-[#DA1E28] cx-text-white"
            danger
            fullWidth
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteInvoiceModal;
